import { CommonModule } from '@angular/common';
import { Component, Inject, Injectable } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBar } from '@angular/material/snack-bar';
import { NotificationClassEnum } from '../../models/notification-class.enum';

@Injectable({
  providedIn: 'root'
})
export class CVANotificationService {

  constructor(
    private readonly _snackBar: MatSnackBar
  ) { }

  showNotification(
    message: string,
    notificationType: NotificationClassEnum = NotificationClassEnum.INFO,
    duration: number = 5000,
    allowHtml: boolean = false
  ) {
    if (!message?.trim().length) return;

    const config = {
      panelClass: notificationType,
      duration: duration,
      horizontalPosition: 'right' as const,
      verticalPosition: 'top' as const,
    };

    if (allowHtml) {
      this._snackBar.openFromComponent(NotificationSnackbarComponent, {
        ...config,
        data: { message }
      });
      return;
    }

    this._snackBar.open(message, undefined, {
      ...config,
    })
  }
}

interface NotificationSnackbarData {
  message: string;
}

@Component({
  selector: 'cva-standalone-notification-snackbar',
  standalone: true,
  imports: [CommonModule],
  template: `<div class="notification-snackbar" [innerHTML]="data.message"></div>`,
})
export class NotificationSnackbarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: NotificationSnackbarData
  ) { }
}
